/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
const errors = {
  basic: 'Sorry, something went wrong. Please try again in a minute.',
  assert: 'The request failed to be validated.'
}

export default errors
